import { AggregationGroup } from 'src/app/services/jsonrpc/stats-server.service';
import { AnalyticsMetric } from 'src/app/services/stats.service';

import { Dashboard } from './dashboard.component';

const content: Dashboard = {
  widgets: [
    {
      size: 3,
      component: 'users'
    },
    {
      size: 3,
      component: 'usersPeak'
    },
    {
      size: 3,
      component: 'usersPeakDate'
    },
    {
      size: 3,
      component: 'totalActiveTime'
    },

    {
      size: 12,
      component: 'multiTable',
      settings: {
        title: 'Overview',
        grouping: null,
        rows: [
          { title: 'Registered Users', metric: AnalyticsMetric.users },
          { title: 'Active Users', metric: AnalyticsMetric.active_users },
          { title: 'Games Played', metric: AnalyticsMetric.games_played },
          { title: 'Total Active Time', metric: AnalyticsMetric.time },
          { title: '... of it Quiz', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'quiz' } },
          { title: '... of it Wiki', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'wiki' } },
          { title: '... of it Flashcard', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'flashcard' } }
        ],
        totalColumn: true
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Monthly Active Users',
        metric: AnalyticsMetric.active_users,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Daily Playtime',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.date,
        timespan: { days: 21 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Weekly Playtime',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Monthly Playtime',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      size: 12,
      component: 'transitionGraph'
    }
  ]
};

export default content;
